export const ADMIN_ROLE = "ADMIN";
export const AUTHOR_ROLE = "AUTHOR";
export const SUBSCRIBER_ROLE = "SUBSCRIBER";
